module.exports = __webpack_public_path__ + "img/744.a7d065f6.jpg";